import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const SITE_SUFFIX = ' | ShipTanbul'

/** Map of path patterns to page titles (without suffix). Exact paths first, then prefixes for dynamic routes. */
const PAGE_TITLES: { pattern: string; title: string }[] = [
  // Auth
  { pattern: '/login', title: 'התחברות לאזור האישי' },
  { pattern: '/welcome', title: 'התחברות לאזור האישי' },
  { pattern: '/forgot-password', title: 'שחזור סיסמה' },
  // Client area
  { pattern: '/my-area/addresses', title: 'הכתובות שלי' },
  { pattern: '/my-area/packages/unite', title: 'איחוד חבילות' },
  { pattern: '/my-area/packages', title: 'החבילות שלי' },
  { pattern: '/my-area/profile/affiliate', title: 'שיווק שותפים' },
  { pattern: '/my-area/profile/addresses', title: 'הפרופיל שלי' },
  { pattern: '/my-area/profile/personal', title: 'הפרופיל שלי' },
  { pattern: '/my-area/profile', title: 'הפרופיל שלי' },
  // Dynamic client routes (prefix match)
  { pattern: '/my-area/packages/return', title: 'החזרת חבילה' },
  { pattern: '/receipt-upload', title: 'העלאת קבלה' },
  { pattern: '/payment', title: 'תשלום' },
  // Office (English)
  { pattern: '/office-ship', title: 'Office - Ship' },
  { pattern: '/office-e&u', title: 'Office - Edit & Update' },
  { pattern: '/office-packageRequests', title: 'Package Requests' },
  { pattern: '/office-print', title: 'Office - Print' },
  { pattern: '/office-checkForm', title: 'Checklist' },
  { pattern: '/office-stats', title: 'Statistics' },
  { pattern: '/office-popular-brands-items', title: 'Popular Brands Items' },
  { pattern: '/office-affiliate', title: 'Affiliates' },
  { pattern: '/office-coupon', title: 'Coupons' },
  { pattern: '/office-receive-shipments', title: 'Receive Shipments' },
  { pattern: '/office-delayed-payments', title: 'Delayed Payments' },
  { pattern: '/office-ship-barcode-gun', title: 'Barcode Gun' },
  { pattern: '/office-location', title: 'Location' },
  { pattern: '/office-scan-me', title: 'Scan Me' },
  { pattern: '/office-warehouse-arrivals', title: 'Warehouse Arrivals' },
  { pattern: '/office-pickup-orders', title: 'Pickup Orders' },
  { pattern: '/office-scan-orders', title: 'Scan Orders' },
  { pattern: '/office-sticker', title: 'Sticker' },
  { pattern: '/office', title: 'New Package' },
]

const DEFAULT_TITLE = 'אזור אישי' + SITE_SUFFIX

function getTitleForPath(pathname: string): string {
  // Exact match first
  const exact = PAGE_TITLES.find(({ pattern }) => pathname === pattern || pathname === pattern + '/')
  if (exact) return exact.title + SITE_SUFFIX

  // Prefix match for dynamic segments (e.g. /receipt-upload/123, /payment/shipping/123)
  const prefix = PAGE_TITLES.find(({ pattern }) => pathname.startsWith(pattern + '/'))
  if (prefix) return prefix.title + SITE_SUFFIX

  // Root
  if (pathname === '/' || pathname === '') return 'התחברות לאזור האישי' + SITE_SUFFIX

  return DEFAULT_TITLE
}

/**
 * Sets document.title based on the current route. Use once in the app root (e.g. Layout).
 */
export function usePageTitle(): void {
  const { pathname } = useLocation()

  useEffect(() => {
    document.title = getTitleForPath(pathname)
  }, [pathname])
}
